import { BorderGridContainer, ContentTiles } from '@ahmdigital/ui';
import type { ComponentProps } from 'react';

import getFootnoteSerializer from '../../utils/get-footnote-serializer';
import styles from './styles.module.sass';
import type { Tile } from './types';

type Props = {
  contentTiles: Tile[][] | undefined;
};

const formatContentTile = (tile: Tile) => {
  const { ctas, footnote, ...tileProps } = tile;
  const formattedCtas = ctas?.map(({ name, url, ...cta }) => ({ ...cta, link: url, linkText: name }));
  const [primaryCta] = ctas || [];

  return {
    ...tileProps,
    ctas: formattedCtas,
    customSerializers: footnote ? getFootnoteSerializer({ footnote, variant: styles.footnote }) : {},
    id: primaryCta?.url || primaryCta?.name || String(tile.title),
    variant: 'vertical',
  };
};

const ContentTilesSection = ({ contentTiles }: Props) => {
  if (!contentTiles?.length) {
    return null;
  }

  const tiles = contentTiles.flat().map(formatContentTile) as ComponentProps<typeof ContentTiles>['tiles'];

  return (
    <BorderGridContainer>
      <ContentTiles tiles={tiles} />
    </BorderGridContainer>
  );
};

export default ContentTilesSection;
